import {
  AssessmentType,
  CalibrationNodeFragment,
  MostRecentAssessmentAnswerNode,
} from "types/graphql-schema";
import { BasicUser } from "types/topicflow";

import useLabel from "@apps/use-label/use-label";

import AssessmentQuestionChrome from "./assessment-question-chrome";
import AssessmentQuestionHeading from "./assessment-question-heading";
import { getQuestionClass } from "./question";
import {
  AssessmentAnswer,
  AssessmentAnswerWithResponderAndId,
  AssessmentQuestion,
} from "./types";

const AssessmentQuestionItem = ({
  answer,
  mostRecentAnswer,
  assessmentType,
  otherParticipantsAnswers,
  formDisabled,
  question,
  showError,
  target,
  periodStartDate,
  periodEndDate,
  calibrations,
  onUpdateAnswer,
}: {
  assessmentType: AssessmentType;
  answer?: AssessmentAnswer;
  mostRecentAnswer?: Pick<
    MostRecentAssessmentAnswerNode,
    "integerAnswer" | "submitted"
  >;
  otherParticipantsAnswers?: AssessmentAnswerWithResponderAndId[];
  calibrations?: CalibrationNodeFragment[];
  formDisabled: boolean;
  question: AssessmentQuestion;
  showError: boolean;
  target?: BasicUser | null;
  periodStartDate?: string | null;
  periodEndDate?: string | null;
  onUpdateAnswer: (answer: AssessmentAnswer) => void;
}) => {
  const label = useLabel();
  const QuestionClass = getQuestionClass(question, { label });

  const questionAnswered =
    QuestionClass.isQuestionAnswered(answer) &&
    QuestionClass.hasEnteredComment(answer);

  const questionContent = QuestionClass.getForm({
    answer,
    assessmentType,
    otherParticipantsAnswers,
    onUpdateAnswer,
    target,
    formDisabled,
    periodStartDate,
    periodEndDate,
    calibrations,
  });

  return (
    <AssessmentQuestionChrome
      key={question.id}
      isQuestionAnswered={!!questionAnswered}
      isShowingError={showError}
      aria-label={`Assessment question: ${question.title}`}
      id={`assessment-question-${question.id}`}
    >
      <div className="px-6 pt-6">
        <AssessmentQuestionHeading
          question={question}
          target={target}
          mostRecentAnswer={mostRecentAnswer}
          assessmentType={assessmentType}
        />
      </div>

      <div className="mt-4">{questionContent}</div>
    </AssessmentQuestionChrome>
  );
};

export default AssessmentQuestionItem;
